import * as Yup from 'yup';

export default Yup.object().shape({
  payday: Yup.number()
    .required('SCHEMA_ERRORS.REQUIRED_FIELD')
    .min(1, 'SCHEMA_ERRORS.PAYDAY_MIN')
    .max(31, 'SCHEMA_ERRORS.PAYDAY_MAX_EDIT')
});
